import React from 'react';
import OpportunityDetail from '../components/opportunities/OpportunityDetail';

const OpportunityDetailPage = () => {
  return <OpportunityDetail />;
};

export default OpportunityDetailPage;
